import { render } from "./AppAboutUs.vue?vue&type=template&id=eb6ea646"
import script from "./AppAboutUs.vue?vue&type=script&lang=js"
export * from "./AppAboutUs.vue?vue&type=script&lang=js"

import "./AppAboutUs.vue?vue&type=style&index=0&id=eb6ea646&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__